import React, { PropsWithChildren } from "react";
import LoadingWithOverlayProvider from "./loading-with-overlay/loading-with-overlay-provider";
import { CustomSnackbarProvider } from "./SimplePopups/CustomSnackbarProvider";
import SimplePopupProvider from "./SimplePopups/SimplePopupProvider";

interface IProps extends PropsWithChildren {}

export const Providers = ({ children }: IProps): React.ReactElement<IProps> => {

  return (
    <LoadingWithOverlayProvider>
      <CustomSnackbarProvider>
        <SimplePopupProvider>{children}</SimplePopupProvider>
      </CustomSnackbarProvider>
    </LoadingWithOverlayProvider>
  );
};
